// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"_6yJp27OXeSKmVJANBu7bO b-notice-box b-notice-box--info b-notice-box--with-icon","infoIcon":"_26UrMIqWx0VJtSNtVsPZzu b-notice-box__icon"};